import { render, staticRenderFns } from "./ModalAtendimentoIncompleto.vue?vue&type=template&id=033f4859&scoped=true&"
import script from "./ModalAtendimentoIncompleto.vue?vue&type=script&lang=js&"
export * from "./ModalAtendimentoIncompleto.vue?vue&type=script&lang=js&"
import style0 from "./ModalAtendimentoIncompleto.vue?vue&type=style&index=0&id=033f4859&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033f4859",
  null
  
)

export default component.exports